import React from "react";
import { Box, Grid, TextField, Typography } from "@mui/material";
import {
  EditorFormNav,
  EditorListHeader,
  EditorListItem,
  EditorSection,
} from "./institutional/InstitutionalEditorParts";
import { emptySiteNav, emptySiteNavItem } from "../../utils/siteNavContent";

const NAV = [
  { id: "sec-nav-labels", label: "Rótulos" },
  { id: "sec-nav-phone", label: "Telefone" },
  { id: "sec-nav-primary", label: "Menu principal" },
  { id: "sec-nav-more", label: "Menu Mais" },
];

export default function SiteNavEditor({ value, onChange }) {
  const v = value?.format === "site_nav.v1" ? value : emptySiteNav();
  const set = (patch) => onChange({ ...v, ...patch });
  const setPhone = (patch) => set({ phone: { ...(v.phone || {}), ...patch } });

  const setItem = (key, i, patch) => {
    const next = [...(v[key] || [])];
    next[i] = { ...next[i], ...patch };
    set({ [key]: next });
  };

  const renderItems = (key, title, subtitle) => {
    const items = Array.isArray(v[key]) ? v[key] : [];
    return (
      <EditorSection id={`sec-nav-${key}`} title={title} subtitle={subtitle} badge={items.length || null}>
        <EditorListHeader
          onAdd={() => set({ [key]: [...items, emptySiteNavItem()] })}
          addLabel="+ Adicionar item"
        />
        {items.map((item, i) => (
          <EditorListItem
            key={`${key}-${i}`}
            index={i}
            title={item.label ? `${i + 1}. ${item.label}` : `Item ${i + 1}`}
            summary={item.href}
            defaultExpanded={i === items.length - 1}
            onDelete={() => set({ [key]: items.filter((_, idx) => idx !== i) })}
          >
            <Grid container spacing={1.5}>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Rótulo"
                  value={item.label || ""}
                  onChange={(e) => setItem(key, i, { label: e.target.value })}
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="URL"
                  value={item.href || ""}
                  onChange={(e) => setItem(key, i, { href: e.target.value })}
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Título (tooltip, opcional)"
                  value={item.title || ""}
                  onChange={(e) => setItem(key, i, { title: e.target.value })}
                  size="small"
                  fullWidth
                />
              </Grid>
            </Grid>
          </EditorListItem>
        ))}
      </EditorSection>
    );
  };

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Menu do cabeçalho do site. Sem estes itens, o topo fica só com logo e conta.
      </Typography>
      <EditorFormNav sections={NAV} />

      <EditorSection id="sec-nav-labels" title="Rótulos do cabeçalho" defaultExpanded>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField label="Texto alternativo do logo" value={v.logoAlt || ""} onChange={(e) => set({ logoAlt: e.target.value })} fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField label="Rótulo do menu Mais" value={v.moreLabel || ""} onChange={(e) => set({ moreLabel: e.target.value })} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="Entrar" value={v.loginLabel || ""} onChange={(e) => set({ loginLabel: e.target.value })} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="Sair" value={v.logoutLabel || ""} onChange={(e) => set({ logoutLabel: e.target.value })} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="Sair (menu mobile)" value={v.logoutFullLabel || ""} onChange={(e) => set({ logoutFullLabel: e.target.value })} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="Minha conta" value={v.accountLabel || ""} onChange={(e) => set({ accountLabel: e.target.value })} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="Minhas viagens (menu da conta)" value={v.tripsLabel || ""} onChange={(e) => set({ tripsLabel: e.target.value })} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="Abrir menu" value={v.openMenuLabel || ""} onChange={(e) => set({ openMenuLabel: e.target.value })} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="Fechar menu" value={v.closeMenuLabel || ""} onChange={(e) => set({ closeMenuLabel: e.target.value })} fullWidth />
          </Grid>
        </Grid>
      </EditorSection>

      <EditorSection id="sec-nav-phone" title="Telefone no cabeçalho">
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <TextField label="Rótulo" value={v.phone?.label || ""} onChange={(e) => setPhone({ label: e.target.value })} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="Link (tel:)" value={v.phone?.href || ""} onChange={(e) => setPhone({ href: e.target.value })} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="Rótulo no menu mobile" value={v.phone?.mobileLabel || ""} onChange={(e) => setPhone({ mobileLabel: e.target.value })} fullWidth />
          </Grid>
        </Grid>
      </EditorSection>

      {renderItems("primary", "Menu principal", "Itens visíveis no topo (desktop)")}
      {renderItems("more", "Menu Mais", "Itens dentro do dropdown Mais")}
    </Box>
  );
}
